function getIndustryBonusRequestOneData(cc, reqid, at) {
  const IBRequest = {
    channelIdentifier: 'maps',
    countryCode: cc,
    accountToken: at,
    requestIdentifier: reqid,
  };

  return IBRequest;
}

export default getIndustryBonusRequestOneData;
